

'use strict';

/* ── XSS utility ── */
function escapeHtml(str) {
  if (str == null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/* ── Scroll Reveal ── */
(function () {
  const els = document.querySelectorAll('.js-reveal');
  if (!els.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const delay = parseInt(el.dataset.revealDelay) || 0;
        setTimeout(() => el.classList.add('is-visible'), delay);
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.12 });

  els.forEach(el => observer.observe(el));
})();

/* ── Announcement Bar ── */
(function () {
  const bar = document.getElementById('announcement-bar');
  if (!bar) return;
  const items = bar.querySelectorAll('.announcement-bar__item');
  const closeBtn = bar.querySelector('.announcement-bar__close');
  const prevBtn = bar.querySelector('.announcement-bar__prev');
  const nextBtn = bar.querySelector('.announcement-bar__next');
  let current = 0;

  function show(index) {
    items.forEach((el, i) => el.classList.toggle('is-active', i === index));
  }

  if (prevBtn) prevBtn.addEventListener('click', () => { current = (current - 1 + items.length) % items.length; show(current); });
  if (nextBtn) nextBtn.addEventListener('click', () => { current = (current + 1) % items.length; show(current); });
  if (closeBtn) closeBtn.addEventListener('click', () => { bar.style.display = 'none'; });

  if (items.length > 1) setInterval(() => { current = (current + 1) % items.length; show(current); }, 5000);
})();

/* ── Header: mobile menu + mega menu ── */
(function () {
  const toggle = document.querySelector('.site-header__mobile-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  if (toggle && mobileMenu) {
    toggle.addEventListener('click', () => {
      if (window.innerWidth <= 767) return; // mob-nav handles mobile
      const open = mobileMenu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
      mobileMenu.setAttribute('aria-hidden', !open);
    });
  }

  // Mobile accordion
  document.querySelectorAll('.mobile-accordion__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const content = btn.nextElementSibling;
      const open = content.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
    });
  });
})();

/* ── Search overlay ── */
(function () {
  const overlay = document.getElementById('search-overlay');
  const input = document.getElementById('search-input');
  const closeBtn = document.getElementById('search-backdrop');
  const closeBtnX = document.getElementById('search-close');
  const resultsContainer = document.getElementById('search-results');

  if (!overlay) return;

  function openSearch() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input && input.focus(), 50);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (resultsContainer) resultsContainer.innerHTML = '';
  }

  document.querySelectorAll('.search-toggle').forEach(btn => {
    btn.addEventListener('click', openSearch);
  });

  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (closeBtnX) closeBtnX.addEventListener('click', closeSearch);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeSearch();
  });

  // Predictive search
  let searchTimer = null;
  if (input && resultsContainer) {
    input.addEventListener('input', function() {
      clearTimeout(searchTimer);
      const query = input.value.trim();
      if (query.length < 2) { resultsContainer.innerHTML = ''; return; }
      searchTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
            if (products.length === 0) {
              resultsContainer.innerHTML = '<div class="search-overlay__no-results">No products found</div>';
              return;
            }
            var html = products.map(function(p) {
              var img = p.image ? '<img src="' + p.image.replace(/(\.\w+)(\?|$)/, '_200x$1$2') + '" class="search-overlay__result-img" alt="" loading="lazy">' : '<div class="search-overlay__result-img"></div>';
              var price = p.price ? '₹ ' + (parseFloat(p.price) / 1).toLocaleString('en-IN') : '';
              return '<a href="' + p.url + '" class="search-overlay__result-item">' + img + '<div class="search-overlay__result-info"><div class="search-overlay__result-title">' + escapeHtml(p.title) + '</div><div class="search-overlay__result-price">' + price + '</div></div></a>';
            }).join('');
            html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="search-overlay__view-all">View all results →</a>';
            resultsContainer.innerHTML = html;
          })
          .catch(function() { resultsContainer.innerHTML = ''; });
      }, 300);
    });
  }
})();

/* ── Header: transparent at top, solid on scroll, hide on scroll down ── */
/* ── Header hide on scroll down, show on scroll up ── */
(function () {
  const siteTop = document.getElementById('site-top');
  if (!siteTop) return;

  function syncPadding() {
    // On the homepage, we want the header to float absolutely over the hero image.
    // So we only add padding if it's NOT the homepage.
    if (!document.body.classList.contains('template-index')) {
      document.body.style.paddingTop = siteTop.offsetHeight + 'px';
    } else {
      document.body.style.paddingTop = '0px';
    }
  }

  function syncHeaderHeight() {
    const h = siteTop.offsetHeight;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }

  syncPadding();
  syncHeaderHeight();
  window.addEventListener('resize', () => { syncPadding(); syncHeaderHeight(); });

  // Re-sync when announcement bar is hidden/removed (e.g. user closes it)
  new MutationObserver(() => {
    syncPadding();
    syncHeaderHeight();
  }).observe(siteTop, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

  let lastY = window.scrollY;
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const currentY = window.scrollY;

        // Toggle glass/solid bg based on scroll position
        if (currentY > 10) {
          siteTop.classList.add('is-scrolled');
        } else {
          siteTop.classList.remove('is-scrolled');
        }

        // Hide on scroll down, show on up
        const headerHiding = currentY > lastY && currentY > 80;
        if (headerHiding) {
          siteTop.classList.add('is-hidden');
        } else {
          siteTop.classList.remove('is-hidden');
        }

        // Toolbar: when header is hidden, stick at top; when header visible, sit below it
        document.querySelectorAll('.collection-toolbar').forEach(tb => {
          if (headerHiding) {
            tb.classList.add('header-hidden');
          } else {
            tb.classList.remove('header-hidden');
          }
        });

        lastY = currentY;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

/* ── Slideshow ── */
(function () {
  document.querySelectorAll('.slideshow').forEach(slider => {
    const slides = slider.querySelectorAll('.slideshow__slide');
    const dots = slider.querySelectorAll('.slideshow__dot');
    const prevBtn = slider.querySelector('.slideshow__arrow--prev');
    const nextBtn = slider.querySelector('.slideshow__arrow--next');
    const autoplay = slider.dataset.autoplay === 'true';
    const speed = (parseInt(slider.dataset.speed) || 6) * 1000;
    let current = 0;
    let timer;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { goTo(current - 1); resetTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { goTo(current + 1); resetTimer(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { goTo(i); resetTimer(); }));

    function resetTimer() { clearInterval(timer); if (autoplay) timer = setInterval(() => goTo(current + 1), speed); }
    if (autoplay && slides.length > 1) timer = setInterval(() => goTo(current + 1), speed);
  });
})();

/* ── Tabs ── */
(function () {
  document.querySelectorAll('[data-tabs]').forEach(tabGroup => {
    // Support both regular tabs and bundle tabs
    const buttons = tabGroup.querySelectorAll('.tabs__btn, .bundle-tabs__btn');
    const panels = tabGroup.querySelectorAll('.tabs__panel');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;
        buttons.forEach(b => { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
        panels.forEach(p => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        const panel = tabGroup.querySelector(`#tab-panel-${target}`);
        if (panel) panel.classList.add('is-active');
      });
    });
  });
})();

/* ── Collapsible tabs (product page) ── */
(function () {
  document.querySelectorAll('.collapsible-tab__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      btn.nextElementSibling.classList.toggle('is-open', !expanded);
    });
  });
})();

/* ── Product media thumbnails ── */
(function () {
  document.querySelectorAll('.product-media__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const id = thumb.dataset.mediaId;
      const container = thumb.closest('.product-media');
      container.querySelectorAll('.product-media__item').forEach(item => item.classList.remove('is-active'));
      container.querySelectorAll('.product-media__thumb').forEach(t => t.classList.remove('is-active'));
      container.querySelector(`[data-media-id="${id}"].product-media__item`)?.classList.add('is-active');
      thumb.classList.add('is-active');
    });
  });
})();

/* ── Variant picker ── */
(function () {
  document.querySelectorAll('[data-product-form]').forEach(form => {
    const formId = form.getAttribute('id') || '';
    const sectionId = formId.replace('product-form-', '');
    const variantData = document.getElementById(`product-variants-${sectionId}`);
    if (!variantData) return;
    const variants = JSON.parse(variantData.textContent);
    const variantInput = document.getElementById(`variant-id-${sectionId}`);
    const priceEl = document.getElementById(`price-${sectionId}`);
    const addBtn = form.querySelector('[data-add-to-cart]');
    const addBtnText = form.querySelector('[data-add-to-cart-text]');

    form.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const position = parseInt(btn.dataset.optionPosition);
        const value = btn.dataset.value;
        const wrapper = btn.closest('.variant-option__buttons') || btn.closest('.mp-sizes__row');
        if (wrapper) wrapper.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        updateVariant();
      });
    });

    form.querySelectorAll('.variant-option__select').forEach(select => {
      select.addEventListener('change', updateVariant);
    });

    function getSelectedOptions() {
      const options = [];
      form.querySelectorAll('.variant-option').forEach(optionEl => {
        const btn = optionEl.querySelector('.variant-btn.is-selected');
        const sel = optionEl.querySelector('.variant-option__select');
        if (btn) options.push(btn.dataset.value);
        else if (sel) options.push(sel.value);
      });
      return options;
    }

    function updateVariant() {
      const selected = getSelectedOptions();
      const match = variants.find(v => v.options.every((opt, i) => opt === selected[i]));
      if (!match) return;
      if (variantInput) variantInput.value = match.id;
      if (addBtn) addBtn.disabled = !match.available;
      if (addBtnText) addBtnText.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    }
  });
})();

/* ── Cart Drawer ── */
(function () {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  function openDrawer() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  document.addEventListener('click', e => {
    if (e.target.closest('[data-cart-toggle]')) { openDrawer(); return; }
    if (e.target.closest('[data-cart-drawer-close]')) {
      // Don't close if clicking a real navigation link inside the drawer
      if (e.target.closest('a[href]') && !e.target.closest('.cart-drawer__overlay')) return;
      closeDrawer();
      return;
    }
  });

  // Remove item
  drawer.addEventListener('click', async e => {
    const removeBtn = e.target.closest('.js-cart-remove');
    const qtyBtn = e.target.closest('.js-cart-qty');

    if (removeBtn) {
      await updateCartItem(removeBtn.dataset.key, 0);
    } else if (qtyBtn) {
      const item = qtyBtn.closest('.cart-drawer__item');
      const currentQty = parseInt(item.querySelector('.qty-input').textContent);
      const change = parseInt(qtyBtn.dataset.change);
      await updateCartItem(qtyBtn.dataset.key, Math.max(0, currentQty + change));
    }
  });

  async function updateCartItem(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const cart = await res.json();
    refreshDrawer(cart);
    updateCartCount(cart.item_count);
  }

  async function addItem(id, quantity = 1, properties = {}) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity, properties })
      });
      if (res.ok) {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartCount(cart.item_count);
        await refreshDrawer(cart);
        openDrawer();
        return { success: true, cart };
      } else {
        const err = await res.json();
        alert(err.description || 'Could not add to cart.');
        return { success: false, error: err };
      }
    } catch (err) {
      console.error('Add to cart error:', err);
      return { success: false, error: err };
    }
  }

  async function refreshDrawer(cart) {
    const drawerItems = document.getElementById('cart-drawer-items');
    const countEl = document.getElementById('cart-drawer-count');
    const totalEl = document.getElementById('cart-drawer-total');
    const footer = document.getElementById('cart-drawer-footer');

    if (countEl) countEl.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price) + ' ' + (cart.currency || '');
    if (footer) footer.style.display = cart.item_count > 0 ? '' : 'none';

    if (!drawerItems) return;

    if (cart.item_count === 0) {
      drawerItems.innerHTML = `
        <div class="cart-drawer__empty">
          <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true">
            <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>
          </svg>
          <p>Your cart is empty</p>
          <button class="btn btn--primary" data-cart-drawer-close>Continue Shopping</button>
        </div>`;
      drawerItems.querySelectorAll('[data-cart-drawer-close]').forEach(el => el.addEventListener('click', closeDrawer));
      return;
    }

    drawerItems.innerHTML = cart.items.map(item => {
      const imgSrc = item.image ? item.image.replace(/(\.\w+)$/, '_160x$1') : '';
      const safeImgSrc = escapeHtml(imgSrc);
      const safeTitle = escapeHtml(item.product_title);
      const safeKey = escapeHtml(item.key);
      const safeHandle = escapeHtml(item.handle);
      const safePrice = escapeHtml(formatMoney(item.original_price));
      const variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? `<p class="cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>` : '';
      return `
        <div class="cart-drawer__item" data-key="${safeKey}">
          <div class="cart-drawer__item-image">
            ${safeImgSrc ? `<img src="${safeImgSrc}" alt="${safeTitle}" width="64" height="80" loading="lazy">` : ''}
          </div>
          <div class="cart-drawer__item-details">
            <div class="cart-drawer__item-top">
              <div class="cart-drawer__item-meta">
                <p class="cart-drawer__item-name">${safeTitle}</p>
                ${variantHtml}
              </div>
              <button class="cart-drawer__item-remove js-cart-remove" data-key="${safeKey}" aria-label="Remove">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div class="cart-drawer__item-bottom">
              <div class="qty-selector qty-selector--sm">
                <button class="qty-btn qty-btn--minus js-cart-qty" data-key="${safeKey}" data-change="-1" aria-label="Decrease">
                  <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2 6h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                </button>
                <span class="qty-input">${item.quantity}</span>
                <button class="qty-btn qty-btn--plus js-cart-qty" data-key="${safeKey}" data-change="1" aria-label="Increase">
                  <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M6 2v8M2 6h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                </button>
              </div>
              <span class="cart-drawer__item-price">${safePrice}</span>
            </div>
            <button class="cart-drawer__move-wishlist js-move-to-wishlist"
              data-product-id="${escapeHtml(String(item.product_id))}"
              data-variant-id="${escapeHtml(String(item.variant_id))}"
              data-item-key="${safeKey}"
              data-product-title="${safeTitle}"
              data-product-price="${safePrice}"
              data-product-image="${safeImgSrc}"
              data-product-handle="${safeHandle}"
              aria-label="Move to wishlist">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
              Move to wishlist
            </button>
          </div>
        </div>`;
    }).join('');

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price) + ' ' + (cart.currency || '');
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => el.textContent = count);
  }

  // Expose globally so other modules (wishlist page, product page) can use it
  window.__oraCart = { refreshDrawer, updateCartCount, openDrawer, addItem };

  function formatMoney(cents) {
    if (!cents) cents = 0;
    if (typeof cents !== 'number') cents = parseInt(cents.toString().replace(/[^0-9]/g, ''), 10);
    if (isNaN(cents)) cents = 0;
    const amountStr = (cents / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    const amountNoDecimalsStr = Math.round(cents / 100).toLocaleString('en-US');
    const fmt = window.Shopify?.moneyFormat || 'Rs. {{ amount }}';
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amountStr)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimalsStr)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountStr)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsStr)
      .replace(/\{\[\s*amount\s*\]\}/g, amountStr)
      .replace(/\{\[\s*amount_no_decimals\s*\]\}/g, amountNoDecimalsStr);
  }

  // Mobile: toggle size pills on product cards via "+" / "×"
  document.addEventListener('click', e => {
    const toggle = e.target.closest('.js-size-toggle');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      const card = toggle.closest('.product-card');
      if (!card) return;
      // Close any other open cards
      document.querySelectorAll('.product-card.sizes-open').forEach(c => {
        if (c !== card) c.classList.remove('sizes-open');
      });
      const open = card.classList.toggle('sizes-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    const closeBtn = e.target.closest('.js-size-close');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const card = closeBtn.closest('.product-card');
      if (card) {
        card.classList.remove('sizes-open');
        const t = card.querySelector('.js-size-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
      return;
    }
  });

  // Add to cart via AJAX (common buttons)
  document.addEventListener('click', async e => {
    const atcBtn = e.target.closest('.js-quick-add, .js-size-atc, [data-add-to-cart]');
    if (!atcBtn) return;
    
    // Skip if the button is inside a .js-sv-atc-toggle (let shop-video handle its own toggle)
    if (atcBtn.classList.contains('js-sv-atc-toggle')) return;
    
    // For [data-add-to-cart], we might need to find the variant ID from the form
    let variantId = atcBtn.dataset.variantId;
    let form = atcBtn.closest('form');
    if (!variantId && form) {
      variantId = form.querySelector('[name="id"]')?.value;
    }
    
    if (!variantId) return;
    
    // Direct AJAX trigger — stop others from redirecting
    e.preventDefault();
    e.stopImmediatePropagation();

    const origText = atcBtn.textContent;
    // Product-card size pills are narrow segments — use a compact indicator
    const isSizePill = atcBtn.classList.contains('product-card__size-pill');
    atcBtn.disabled = true;
    atcBtn.classList.add('is-adding');
    atcBtn.textContent = isSizePill ? '···' : 'Adding...';

    await addItem(variantId, 1);
    
    atcBtn.disabled = false;
    atcBtn.classList.remove('is-adding');
    atcBtn.textContent = origText;

    // Close any open shop-video size dropdown
    const dropdown = atcBtn.closest('.sv-size-dropdown');
    if (dropdown) {
      dropdown.classList.remove('is-open');
      const toggle = dropdown.previousElementSibling;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  }, { capture: true });

  // Fallback for form submission if click is missed or triggered via keyboard
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[action*="/cart/add"], [data-product-form]');
    if (!form) return;
    
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    // Direct AJAX trigger — stop others from redirecting
    e.preventDefault();
    e.stopImmediatePropagation();
    console.log('CART SUBMIT INTERCEPTED', variantId);

    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    
    await addItem(variantId, 1);
    if (btn) btn.disabled = false;
  }, { capture: true });

  // Move to wishlist from cart drawer
  drawer.addEventListener('click', e => {
    const btn = e.target.closest('.js-move-to-wishlist');
    if (!btn) return;
    e.preventDefault();
    const { productId, itemKey, productTitle, productPrice, productImage, variantId, productHandle } = btn.dataset;
    const STORAGE_KEY = 'ora_wishlist';
    let list = [];
    try { list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { list = []; }
    if (!list.find(i => String(i.id) === String(productId))) {
      list.push({ id: productId, variantId: variantId || productId, handle: productHandle, name: productTitle, price: productPrice, image: productImage });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    }
    updateCartItem(itemKey, 0);
    // Update wishlist badge via event so all listeners sync
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  });
})();

/* ── Cart page qty / remove / wishlist ── */
(function () {
  const cartForm = document.getElementById('cart-form');
  if (!cartForm) return;

  const STORAGE_KEY = 'ora_wishlist';

  async function changeQty(key, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    if (res.ok) window.location.reload();
  }

  cartForm.addEventListener('click', async e => {
    // Qty buttons
    const minus = e.target.closest('.qty-btn--minus');
    const plus  = e.target.closest('.qty-btn--plus');
    if (minus || plus) {
      e.preventDefault();
      const row = e.target.closest('.cart-table__row');
      if (!row) return;
      const key = row.dataset.key;
      const input = row.querySelector('.qty-input');
      let qty = parseInt(input.value);
      if (minus) qty = Math.max(0, qty - 1);
      else qty = qty + 1;
      input.value = qty;
      await changeQty(key, qty);
      return;
    }

    // Remove button
    const removeBtn = e.target.closest('.cart-item__remove');
    if (removeBtn) {
      e.preventDefault();
      const row = removeBtn.closest('.cart-table__row');
      const key = row ? row.dataset.key : removeBtn.dataset.key;
      await changeQty(key, 0);
      return;
    }

    // Move to wishlist
    const wishlistBtn = e.target.closest('.js-cart-wishlist');
    if (wishlistBtn) {
      e.preventDefault();
      const { productId, productTitle, productPrice, productImage, key, productHandle } = wishlistBtn.dataset;
      let list = [];
      try { list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { list = []; }
      if (!list.find(i => String(i.id) === String(productId))) {
        list.push({ id: productId, handle: productHandle, name: productTitle, price: productPrice, image: productImage });
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      }
      await changeQty(wishlistBtn.dataset.key, 0);
    }
  });
})();

/* ── Wishlist Page ── */
(function () {
  const STORAGE_KEY = 'ora_wishlist';
  const grid = document.getElementById('wishlist-page-grid');
  if (!grid) return; // only runs on wishlist page

  const emptyEl  = document.getElementById('wishlist-page-empty');
  const countEl  = document.getElementById('wishlist-page-count');
  const moveAllBtn = document.getElementById('wishlist-move-all');

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function render() {
    const list = getWishlist();
    if (countEl) countEl.textContent = list.length > 0 ? `(${list.length})` : '';
    if (moveAllBtn) moveAllBtn.style.display = list.length > 0 ? '' : 'none';

    if (list.length === 0) {
      grid.innerHTML = '';
      if (emptyEl) emptyEl.style.display = '';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';

    grid.innerHTML = list.map(item => `
      <div class="product-card wishlist-card" data-id="${escapeHtml(String(item.id))}">
        <a href="/products/${escapeHtml(item.handle || '')}" class="product-card__media">
          <div class="product-card__media-inner">
            ${item.image
              ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.name)}" loading="lazy" class="product-card__image product-card__image--active">`
              : `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9l4-4 4 4 4-4 4 4"/><circle cx="8.5" cy="13.5" r="1.5"/></svg>`}
            <button class="wishlist-card__remove js-wishlist-remove" data-id="${escapeHtml(String(item.id))}" aria-label="Remove from wishlist">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
            <div class="product-card__sizes wishlist-card__sizes">
              <button class="product-card__size-pill js-wishlist-atc" data-id="${escapeHtml(String(item.id))}" data-variant-id="${escapeHtml(String(item.variantId || ''))}" data-handle="${escapeHtml(item.handle || '')}" data-name="${escapeHtml(item.name)}">Add to Cart</button>
            </div>
          </div>
        </a>
        <div class="product-card__info">
          <div class="product-card__meta">
            <h3 class="product-card__title"><a href="/products/${escapeHtml(item.handle || '')}">${escapeHtml(item.name).toUpperCase()}</a></h3>
          </div>
          <div class="product-card__price">
            <span class="price">${escapeHtml(item.price)}</span>
          </div>
        </div>
      </div>`).join('');
  }

  async function addWishlistItemToCart(productId, variantId) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (res.ok) {
        saveWishlist(getWishlist().filter(i => String(i.id) !== String(productId)));
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
        if (window.__oraCart) {
          window.__oraCart.refreshDrawer(cart);
          window.__oraCart.updateCartCount(cart.item_count);
          window.__oraCart.openDrawer();
        }
        document.dispatchEvent(new CustomEvent('wishlist:updated'));
        render();
      }
    } catch {}
  }

  // Remove item
  grid.addEventListener('click', async e => {
    const removeBtn = e.target.closest('.js-wishlist-remove');
    if (removeBtn) {
      const id = removeBtn.dataset.id;
      saveWishlist(getWishlist().filter(i => String(i.id) !== String(id)));
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
      render();
      return;
    }

    // Variant option clicked inside wishlist dropdown
    const variantBtn = e.target.closest('.wishlist-variant-option');
    if (variantBtn) {
      const productId = variantBtn.dataset.productId;
      const variantId = parseInt(variantBtn.dataset.variantId);
      const dropdown = variantBtn.closest('.wishlist-variant-dropdown');
      if (dropdown) {
        dropdown.style.opacity = '0';
        dropdown.style.pointerEvents = 'none';
        dropdown.style.transform = 'translateY(6px)';
      }
      await addWishlistItemToCart(productId, variantId);
      return;
    }

    // Add to cart — add directly (card has no dropdown markup)
    const atcBtn = e.target.closest('.js-wishlist-atc');
    if (atcBtn) {
      e.preventDefault();
      e.stopPropagation(); // don't trigger the surrounding product link
      if (atcBtn.dataset.loading === '1') return;

      const id = atcBtn.dataset.id;
      const numericVariantId = parseInt(atcBtn.dataset.variantId);
      const handle = atcBtn.dataset.handle;
      const original = atcBtn.textContent;

      atcBtn.dataset.loading = '1';
      atcBtn.textContent = '...';

      try {
        // 1) Use the stored variant id if we have one.
        if (numericVariantId && !isNaN(numericVariantId)) {
          await addWishlistItemToCart(id, numericVariantId);
          return;
        }

        // 2) Otherwise resolve a variant from the product handle.
        if (handle) {
          const res = await fetch(`/products/${handle}.js`);
          if (res.ok) {
            const product = await res.json();
            const variant = product.variants.find(v => v.available) || product.variants[0];
            if (variant) {
              await addWishlistItemToCart(id, variant.id);
              return;
            }
          }
        }

        // 3) Nothing usable.
        atcBtn.textContent = 'Unavailable';
        setTimeout(() => { atcBtn.textContent = original; }, 1500);
      } catch {
        atcBtn.textContent = original;
      } finally {
        delete atcBtn.dataset.loading;
      }
    }
  });

  // Move all to cart then clear wishlist
  if (moveAllBtn) {
    moveAllBtn.addEventListener('click', async () => {
      const list = getWishlist();
      if (!list.length) return;
      moveAllBtn.disabled = true;
      moveAllBtn.textContent = 'Adding...';
      for (const item of list) {
        const addId = item.variantId ? parseInt(item.variantId) : parseInt(item.id);
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: addId, quantity: 1 })
          });
        } catch {}
      }
      // Clear wishlist
      saveWishlist([]);
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
      if (window.__oraCart) {
        window.__oraCart.refreshDrawer(cart);
        window.__oraCart.updateCartCount(cart.item_count);
      }
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
      moveAllBtn.disabled = false;
      moveAllBtn.textContent = 'Move all to cart';
      render();
    });
  }

  render();

  // Re-render when heart toggle fires on same page
  document.addEventListener('wishlist:updated', render);

  // Re-render when localStorage changes from another tab/page
  window.addEventListener('storage', e => {
    if (e.key === STORAGE_KEY) render();
  });
})();

/* ── Wishlist heart toggle (product cards) ── */
(function () {
  const STORAGE_KEY = 'ora_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isWishlisted(id) {
    return getWishlist().some(i => String(i.id) === String(id));
  }

  function updateButtons() {
    document.querySelectorAll('.js-wishlist-toggle').forEach(btn => {
      const id = btn.dataset.productId;
      if (!id) return; // skip buttons with no valid id
      const active = isWishlisted(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active);
    });
    const count = getWishlist().length;
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  document.addEventListener('click', e => {
    const btn = e.target.closest('.js-wishlist-toggle');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.productId ? String(btn.dataset.productId) : null;
    if (!id) return; // no valid id, bail
    const variantId = String(btn.dataset.variantId || id);
    const list = getWishlist();
    const idx = list.findIndex(i => String(i.id) === id);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      const card = btn.closest('.product-card');
      const name = card?.querySelector('.product-card__title')?.textContent?.trim()
        || btn.dataset.name
        || btn.closest('.sv-card__meta')?.querySelector('.sv-card__name')?.textContent?.trim()
        || '';
      const price = card?.querySelector('.product-card__price .price')?.textContent?.trim()
        || btn.dataset.price
        || btn.closest('.sv-card__meta')?.querySelector('.sv-card__price')?.textContent?.trim()
        || '';
      const image = btn.dataset.image
        || card?.querySelector('.product-card__image')?.src
        || btn.closest('.sv-card__info')?.querySelector('.sv-card__thumb')?.src
        || '';
      const href = card?.querySelector('a')?.href || '';
      const handleFromUrl = href.split('/products/')[1]?.split('?')[0] || '';
      const handle = btn.dataset.productHandle || handleFromUrl;
      list.push({ id, variantId, handle, name, price, image });
    }
    saveWishlist(list);
    updateButtons();
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  });

  document.addEventListener('wishlist:updated', updateButtons);
  updateButtons();

  // Sync badge when localStorage changes from another tab
  window.addEventListener('storage', e => {
    if (e.key === STORAGE_KEY) updateButtons();
  });
})();

/* ── Newsletter Popup ── */
(function () {
  const popup = document.getElementById('newsletter-popup');
  if (!popup) return;
  const delay = (parseInt(document.body.dataset.popupDelay) || 3) * 1000;

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    sessionStorage.setItem('newsletter_popup_seen', '1');
  }

  if (!sessionStorage.getItem('newsletter_popup_seen')) {
    setTimeout(() => {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
    }, delay);
  }

  document.getElementById('newsletter-popup-close')?.addEventListener('click', closePopup);
  document.getElementById('newsletter-popup-close-btn')?.addEventListener('click', closePopup);
  document.getElementById('newsletter-popup-close-btn-2')?.addEventListener('click', closePopup);
})();

/* ── Carousel (collection carousel) ── */
(function () {
  document.querySelectorAll('[data-carousel]').forEach(track => {
    const section = track.closest('section');
    const prevBtn = section?.querySelector('.carousel-arrow--prev');
    const nextBtn = section?.querySelector('.carousel-arrow--next');
    const itemWidth = () => (track.querySelector('.carousel-item')?.offsetWidth || 300) + 24;

    if (prevBtn) prevBtn.addEventListener('click', () => track.scrollBy({ left: -itemWidth() * 2, behavior: 'smooth' }));
    if (nextBtn) nextBtn.addEventListener('click', () => track.scrollBy({ left: itemWidth() * 2, behavior: 'smooth' }));
  });
})();

/* ── Product Hotspots ── */
(function () {
  document.querySelectorAll('.hotspot__dot').forEach(dot => {
    dot.addEventListener('click', () => {
      const hotspot = dot.closest('.hotspot');
      const isOpen = dot.getAttribute('aria-expanded') === 'true';

      // Close all others
      document.querySelectorAll('.hotspot__dot').forEach(d => {
        d.setAttribute('aria-expanded', 'false');
        d.closest('.hotspot').removeAttribute('data-open');
      });

      if (!isOpen) {
        dot.setAttribute('aria-expanded', 'true');
        hotspot.setAttribute('data-open', '');
      }
    });
  });

  // Close on outside click
  document.addEventListener('click', e => {
    if (!e.target.closest('.hotspot')) {
      document.querySelectorAll('.hotspot__dot').forEach(d => {
        d.setAttribute('aria-expanded', 'false');
        d.closest('.hotspot').removeAttribute('data-open');
      });
    }
  });
})();

/* ── Image Compare ── */
(function () {
  document.querySelectorAll('[data-compare]').forEach(wrap => {
    const after = wrap.querySelector('.image-compare__after');
    const afterImg = after.querySelector('img');
    const handle = wrap.querySelector('.image-compare__handle');
    let dragging = false;

    function setPosition(x) {
      const rect = wrap.getBoundingClientRect();
      let pct = ((x - rect.left) / rect.width) * 100;
      pct = Math.min(Math.max(pct, 0), 100);
      after.style.width = pct + '%';
      // Keep the image full-width so it doesn't shift
      if (afterImg) afterImg.style.width = rect.width + 'px';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }

    // Init image width on load
    function init() {
      const rect = wrap.getBoundingClientRect();
      if (afterImg) afterImg.style.width = rect.width + 'px';
    }
    init();
    window.addEventListener('resize', init);

    handle.addEventListener('mousedown', e => { dragging = true; e.preventDefault(); });
    handle.addEventListener('touchstart', e => { dragging = true; }, { passive: true });

    document.addEventListener('mousemove', e => { if (dragging) setPosition(e.clientX); });
    document.addEventListener('touchmove', e => { if (dragging) setPosition(e.touches[0].clientX); }, { passive: true });
    document.addEventListener('mouseup', () => { dragging = false; });
    document.addEventListener('touchend', () => { dragging = false; });

    // Keyboard support
    handle.addEventListener('keydown', e => {
      const rect = wrap.getBoundingClientRect();
      const current = parseFloat(after.style.width) || 50;
      if (e.key === 'ArrowLeft') setPosition(rect.left + (current - 5) / 100 * rect.width);
      if (e.key === 'ArrowRight') setPosition(rect.left + (current + 5) / 100 * rect.width);
    });

    // Click anywhere on wrap to jump
    wrap.addEventListener('click', e => {
      if (!e.target.closest('.image-compare__handle')) setPosition(e.clientX);
    });
  });
})();

/* ── FAQ Accordion ── */
(function () {
  document.querySelectorAll('.faq__question').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const answerId = btn.getAttribute('aria-controls');
      const answer = document.getElementById(answerId);

      // Optionally close others in same list
      const list = btn.closest('.faq__list');
      if (list) {
        list.querySelectorAll('.faq__question').forEach(other => {
          if (other !== btn) {
            other.setAttribute('aria-expanded', 'false');
            const otherId = other.getAttribute('aria-controls');
            const otherAnswer = document.getElementById(otherId);
            if (otherAnswer) {
              otherAnswer.style.maxHeight = '0';
              setTimeout(() => { otherAnswer.hidden = true; otherAnswer.style.maxHeight = ''; }, 300);
            }
          }
        });
      }

      if (expanded) {
        btn.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        requestAnimationFrame(() => { answer.style.maxHeight = '0'; });
        setTimeout(() => { answer.hidden = true; answer.style.maxHeight = ''; }, 300);
      } else {
        btn.setAttribute('aria-expanded', 'true');
        answer.hidden = false;
        answer.style.maxHeight = '0';
        requestAnimationFrame(() => { answer.style.maxHeight = answer.scrollHeight + 'px'; });
        setTimeout(() => { answer.style.maxHeight = ''; }, 300);
      }
    });
  });
})();

/* ── Shop Video ── */
(function () {
  document.querySelectorAll('.sv-section').forEach(section => {
    const track = section.querySelector('[data-sv-track]');
    if (!track) return;

    const prevBtn = section.querySelector('[data-sv-prev]');
    const nextBtn = section.querySelector('[data-sv-next]');
    const dots = section.querySelectorAll('.sv-dot');
    const total = parseInt(track.dataset.svTotal) || track.children.length;
    const isMobile = () => window.innerWidth < 768;
    const visibleCount = () => isMobile() ? 1 : (parseInt(track.dataset.svVisible) || 3);
    let offset = 0;

    function maxOffset() {
      return Math.max(0, total - visibleCount());
    }

    function getSlideWidth() {
      const slide = track.querySelector('.sv-slide');
      if (!slide) return 0;
      // recalculate from actual current offsetWidth
      return slide.getBoundingClientRect().width;
    }

    function goTo(index) {
      const max = maxOffset();
      offset = Math.max(0, Math.min(max, index));
      track.style.transform = `translateX(-${offset * getSlideWidth()}px)`;
      dots.forEach((d, i) => d.classList.toggle('sv-dot--active', i === offset));
      if (prevBtn) prevBtn.disabled = offset === 0;
      if (nextBtn) nextBtn.disabled = offset >= max;
      // Update progress bar
      const bar = section.querySelector('.sv-viewall__bar');
      if (bar) {
        const pct = max > 0 ? (offset / max) * 100 : 0;
        bar.style.setProperty('--sv-scroll-progress', Math.min(100, Math.max(5, pct)) + '%');
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(offset - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(offset + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    // Recalculate on resize
    window.addEventListener('resize', () => {
      goTo(offset);
      if (maxOffset() <= 0) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        const dotsWrap = section.querySelector('.sv-dots');
        if (dotsWrap) dotsWrap.style.display = 'none';
      } else {
        if (prevBtn) prevBtn.style.display = '';
        if (nextBtn) nextBtn.style.display = '';
        const dotsWrap = section.querySelector('.sv-dots');
        if (dotsWrap) dotsWrap.style.display = '';
      }
    });

    // Touch swipe support
    let touchStartX = 0;
    let touchStartY = 0;
    track.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    track.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      // Only act on predominantly horizontal swipes
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        if (dx < 0) goTo(offset + 1);
        else goTo(offset - 1);
      }
    }, { passive: true });

    // Init state after layout
    requestAnimationFrame(() => {
      goTo(0);
      // Hide arrows and dots if nothing to scroll
      if (maxOffset() <= 0) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        const dotsWrap = section.querySelector('.sv-dots');
        if (dotsWrap) dotsWrap.style.display = 'none';
      }
    });

    // ATC dropdown toggle
    section.querySelectorAll('.js-sv-atc-toggle').forEach(btn => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        const dropdown = btn.nextElementSibling;
        const isOpen = dropdown.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen);
        document.querySelectorAll('.sv-size-dropdown.is-open').forEach(d => {
          if (d !== dropdown) { d.classList.remove('is-open'); d.previousElementSibling?.setAttribute('aria-expanded', 'false'); }
        });
      });
    });

    // Size option click
    section.querySelectorAll('.sv-size-option.js-quick-add').forEach(pill => {
      pill.addEventListener('click', async e => {
        e.stopPropagation();
        const variantId = pill.dataset.variantId;
        if (!variantId) return;
        pill.textContent = '...';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (res.ok) {
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();
            if (window.__oraCart) { window.__oraCart.updateCartCount(cart.item_count); window.__oraCart.refreshDrawer(cart); window.__oraCart.openDrawer(); }
          }
        } finally {
          pill.textContent = pill.dataset.origText || pill.textContent;
          const dropdown = pill.closest('.sv-size-dropdown');
          if (dropdown) { dropdown.classList.remove('is-open'); dropdown.previousElementSibling?.setAttribute('aria-expanded', 'false'); }
        }
      });
      pill.dataset.origText = pill.textContent;
    });

    // Mute toggle
    section.querySelectorAll('.js-sv-mute').forEach(btn => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        const card = btn.closest('.sv-card__media');
        const video = card?.querySelector('.js-sv-video');
        const iconMuted = btn.querySelector('.icon-muted');
        const iconUnmuted = btn.querySelector('.icon-unmuted');
        if (!video) return;
        video.muted = !video.muted;
        if (iconMuted) iconMuted.style.display = video.muted ? '' : 'none';
        if (iconUnmuted) iconUnmuted.style.display = video.muted ? 'none' : '';
      });
    });

    // Play videos on hover only (desktop)
    section.querySelectorAll('.sv-slide').forEach(slide => {
      const video = slide.querySelector('.js-sv-video');
      if (!video) return;
      // Ensure correct attributes for autoplay policy
      video.preload = 'auto';
      video.setAttribute('playsinline', '');
      video.setAttribute('muted', '');
      video.muted = true;

      // Play on hover over media area only
      const mediaArea = slide.querySelector('.sv-card__media');
      if (mediaArea) {
        mediaArea.addEventListener('mouseenter', () => {
          video.muted = true;
          video.play().catch(() => {});
        });
        mediaArea.addEventListener('mouseleave', () => {
          video.pause();
          video.currentTime = 0;
        });
      }
      // Mobile tap to toggle play
      const mediaEl = slide.querySelector('.sv-card__media');
      if (mediaEl) {
        mediaEl.addEventListener('click', (e) => {
          if (e.target.closest('button')) return;
          video.muted = true;
          if (video.paused) { video.play().catch(() => {}); }
          else { video.pause(); video.currentTime = 0; }
        });
      }
    });
  });
})();

/* ── Product card image swap on mouse direction ── */
(function () {
  function initCard(card) {
    const imgs = Array.from(card.querySelectorAll('[data-pc-img]'));
    if (imgs.length < 2) return;
    let current = 0;
    let lastX = null;
    let cooldown = false;

    function syncDots(i) {
      const dots = card.querySelectorAll('.product-card__dot');
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
    }

    function goTo(i) {
      imgs[current].classList.remove('product-card__image--active');
      current = (i + imgs.length) % imgs.length;
      imgs[current].classList.add('product-card__image--active');
      syncDots(current);
    }

    // Touch devices: horizontal swipe carousel — track scroll position, update dots.
    const isTouch = window.matchMedia('(max-width: 767px)').matches ||
      ('ontouchstart' in window);

    if (isTouch) {
      const track = card.querySelector('.product-card__slider') ||
        card.querySelector('.product-card__media-inner');
      if (track) {
        let raf = null;
        track.addEventListener('scroll', () => {
          if (raf) return;
          raf = requestAnimationFrame(() => {
            raf = null;
            const slideW = track.clientWidth || 1;
            const idx = Math.round(track.scrollLeft / slideW);
            const clamped = Math.max(0, Math.min(imgs.length - 1, idx));
            if (clamped !== current) {
              current = clamped;
              syncDots(current);
            }
          });
        }, { passive: true });

        // Tap vs swipe: a tap (no significant move) opens the product page.
        const link = card.querySelector('.product-card__link-overlay');
        const href = (link && link.getAttribute('href')) ||
          (card.querySelector('.product-card__title a') || {}).href;
        let startX = 0, startY = 0, moved = false;
        track.addEventListener('touchstart', e => {
          const t = e.touches[0];
          startX = t.clientX; startY = t.clientY; moved = false;
        }, { passive: true });
        track.addEventListener('touchmove', e => {
          const t = e.touches[0];
          if (Math.abs(t.clientX - startX) > 8 || Math.abs(t.clientY - startY) > 8) {
            moved = true;
          }
        }, { passive: true });
        track.addEventListener('touchend', () => {
          if (!moved && href) window.location.href = href;
        });

        // Tapping a dot scrolls to that image
        card.querySelectorAll('.product-card__dot').forEach((dot, idx) => {
          dot.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' });
          });
        });
      }
      return; // skip desktop mouse-move behavior on touch
    }

    card.addEventListener('mousemove', e => {
      if (cooldown) return;
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      if (lastX === null) { lastX = x; return; }
      const diff = x - lastX;
      if (Math.abs(diff) < 8) return; // ignore tiny movements
      cooldown = true;
      setTimeout(() => { cooldown = false; }, 300);
      if (diff > 0) goTo(current + 1);
      else goTo(current - 1);
      lastX = x;
    });

    card.addEventListener('mouseleave', () => {
      goTo(0);
      lastX = null;
    });
  }

  document.querySelectorAll('.product-card').forEach(initCard);
  new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => {
    if (n.nodeType !== 1) return;
    if (n.classList && n.classList.contains('product-card')) initCard(n);
    n.querySelectorAll && n.querySelectorAll('.product-card').forEach(initCard);
  }))).observe(document.body, { childList: true, subtree: true });
})();


// Policy page callout box - only on privacy policy and terms of service
(function() {
  var path = window.location.pathname;
  var calloutData = null;
  if (path === '/policies/privacy-policy') {
    calloutData = {
      title: 'PLEASE READ BEFORE PLACING YOUR ORDER',
      body: 'Last Updated: October 2026<br>At ORA Indie, we respect your privacy and are committed to protecting the personal information you share with us.'
    };
  } else if (path === '/policies/terms-of-service') {
    calloutData = {
      title: 'PLEASE READ BEFORE PLACING YOUR ORDER',
      body: 'Last Updated: October 2026<br>This website is operated by ORA Indie Private Limited. By using our website or placing an order with ORA INDIE, you agree to these Terms of Service along with our Privacy Policy, Shipping Policy and Return &amp; Exchange Policy.'
    };
  } else if (path === '/policies/shipping-policy') {
    calloutData = {
      title: 'PLEASE READ BEFORE PLACING YOUR ORDER',
      body: 'By placing an order with ORA indie, you confirm that you have read and accepted our Shipping &amp; Delivery Policy. Please double-check your delivery address, pin code and contact details before completing your purchase.'
    };
  } else if (path === '/policies/refund-policy') {
    calloutData = {
      title: 'PLEASE READ BEFORE PLACING YOUR ORDER',
      body: 'By placing an order with ORA indie, you confirm that you have read and agreed to our Return Policy. We recommend checking the product details, size guide and return conditions carefully before purchasing.'
    };
  } else if (path === '/pages/store-credit') {
    calloutData = {
      title: 'PLEASE READ BEFORE PLACING YOUR ORDER',
      body: 'ORA Store Credit is a balance added directly to your ORA indie account valid for 6 months. Simply log in to your account, check your available balance and choose to use it during checkout.<br>No codes. No separate gift cards. Your Store Credit stays directly in your ORA indie account.'
    };
  } else if (path === '/pages/exchange-policy') {
    calloutData = {
      title: 'PLEASE READ BEFORE PLACING YOUR ORDER',
      body: 'By placing an order with ORA indie, you confirm that you have read and agreed to our Return Policy. We recommend checking the product details, size guide and return conditions carefully before purchasing.'
    };
  }
  // Rename titles (before callout check so they work even without callout)
  var title = document.querySelector('.shopify-policy__title') || document.querySelector('.policy-styled-page__title') || document.querySelector('.page-hero__title');
  if (path === '/policies/refund-policy' && title) {
    title.textContent = 'Return Policy';
  }
  if (path.indexOf('/pages/faq') > -1 && title) {
    title.textContent = 'Frequently Asked Questions';
  }

  if (!calloutData) {
    // Still run gap fixes even without callout
    if (path.indexOf('store-credit') > -1 || path.indexOf('exchange-policy') > -1 || path.indexOf('/pages/faq') > -1) {
      var gapFix = document.createElement('style');
      gapFix.textContent = '.policy-styled-page{padding-top:55px!important}#shopify-section-footer{background:#ffffff!important}.site-footer{background:var(--bg)!important}.policy-links-bar{background:#ffffff!important;padding-top:1rem!important}';
      document.head.appendChild(gapFix);
      document.body.style.setProperty('background', '#ffffff', 'important');
    }
    return;
  }
  if (!title) return;
  var callout = document.createElement('div');
  callout.className = 'policy-callout-box';
  callout.innerHTML = '<div class="policy-callout-box__title">' + calloutData.title + '</div>' +
    '<div class="policy-callout-box__body">' + calloutData.body + '</div>';
  title.parentNode.insertBefore(callout, title.nextSibling);

  // Store credit, exchange policy & FAQ page: reduce gaps
  if (path.indexOf('store-credit') > -1 || path.indexOf('exchange-policy') > -1 || path.indexOf('/pages/faq') > -1) {
    var gapFix = document.createElement('style');
    gapFix.textContent = '.policy-callout-box{margin-bottom:1rem!important}.policy-styled-page__body>*:first-child{margin-top:1rem!important}.policy-styled-page{padding-top:55px!important}#shopify-section-footer{background:#ffffff!important}.site-footer{background:var(--bg)!important}.policy-links-bar{background:#ffffff!important;padding-top:1rem!important}';
    document.head.appendChild(gapFix);
    document.body.style.setProperty('background', '#ffffff', 'important');
  }
})();

/* ── Shop Video: variant dropdown toggle ── */
(function () {
  // Toggle dropdown open/close when bag icon is clicked
  document.addEventListener('click', function (e) {
    const toggleBtn = e.target.closest('.js-sv-atc-toggle');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      const wrap = toggleBtn.closest('.sv-atc-wrap');
      if (!wrap) return;
      const dropdown = wrap.querySelector('.sv-size-dropdown');
      if (!dropdown) return;
      const isOpen = dropdown.classList.toggle('is-open');
      toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      dropdown.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      // Close all other open dropdowns
      document.querySelectorAll('.sv-size-dropdown.is-open').forEach(function (d) {
        if (d !== dropdown) {
          d.classList.remove('is-open');
          d.setAttribute('aria-hidden', 'true');
          var btn = d.closest('.sv-atc-wrap') && d.closest('.sv-atc-wrap').querySelector('.js-sv-atc-toggle');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
      return;
    }

    // Click on a variant option → add to cart and close dropdown
    const option = e.target.closest('.sv-size-option');
    if (option && !option.disabled) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = option.dataset.variantId;
      if (!variantId) return;
      const dropdown = option.closest('.sv-size-dropdown');
      const wrap = option.closest('.sv-atc-wrap');
      const toggleBtn = wrap && wrap.querySelector('.js-sv-atc-toggle');
      // Visual feedback
      option.classList.add('is-adding');
      const origText = option.textContent;
      option.textContent = '···';
      // Add to cart
      if (window.__oraCart && window.__oraCart.addItem) {
        window.__oraCart.addItem(variantId, 1).then(function () {
          option.classList.remove('is-adding');
          option.textContent = origText;
          // Close dropdown
          if (dropdown) {
            dropdown.classList.remove('is-open');
            dropdown.setAttribute('aria-hidden', 'true');
          }
          if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
        });
      }
      return;
    }

    // Click outside any dropdown → close all
    if (!e.target.closest('.sv-atc-wrap')) {
      document.querySelectorAll('.sv-size-dropdown.is-open').forEach(function (d) {
        d.classList.remove('is-open');
        d.setAttribute('aria-hidden', 'true');
        var btn = d.closest('.sv-atc-wrap') && d.closest('.sv-atc-wrap').querySelector('.js-sv-atc-toggle');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();


/* ── Mobile full-screen nav (mob-nav) ── */
(function () {
  var nav       = document.getElementById('mob-nav');
  var hamburger = document.querySelector('.site-header__mobile-toggle');
  var siteTop   = document.getElementById('site-top');
  if (!nav || !hamburger) return;

  function isMobile() { return window.innerWidth <= 767; }

  function openNav() {
    // Position nav right below the full fixed top bar (header + announcement bar)
    if (siteTop) nav.style.top = siteTop.getBoundingClientRect().bottom + 'px';
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    hamburger.setAttribute('aria-expanded', 'true');
    if (siteTop) siteTop.classList.add('menu-open'); // style header white+blur while menu is open
  }

  function closeNav() {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    hamburger.setAttribute('aria-expanded', 'false');
    if (siteTop) siteTop.classList.remove('menu-open');
  }

  hamburger.addEventListener('click', function () {
    if (!isMobile()) return;
    nav.classList.contains('is-open') ? closeNav() : openNav();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
  });

  window.addEventListener('resize', function () {
    if (!isMobile() && nav.classList.contains('is-open')) closeNav();
  });

  // Accordion rows
  nav.querySelectorAll('[data-mob-acc]').forEach(function (block) {
    var btn  = block.querySelector('[data-mob-acc-btn]');
    var body = block.querySelector('[data-mob-acc-body]');
    if (!btn || !body) return;

    btn.addEventListener('click', function () {
      var isOpen = body.classList.contains('is-open');
      nav.querySelectorAll('[data-mob-acc-body].is-open').forEach(function (ob) {
        if (ob !== body) {
          ob.classList.remove('is-open');
          var sb = ob.previousElementSibling;
          if (sb) sb.setAttribute('aria-expanded', 'false');
        }
      });
      body.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
})();
